/** Dhara = rule for how many days interest is charged (matches backend utils/dharaInterest.js). */

export const DEFAULT_DHARA_LEGAL = '30_day';

function slabDhara(actualDays, firstMin) {
  if (actualDays <= firstMin) return firstMin;
  let charged = firstMin;
  let remaining = actualDays - firstMin;
  while (remaining > 0) {
    const chunk = Math.min(remaining, 30);
    charged += chunk <= 15 ? 15 : 30;
    remaining -= chunk;
  }
  return charged;
}

export function computeChargedDays(actualDays, dhara) {
  const days = Math.max(0, Math.floor(Number(actualDays) || 0));
  if (days === 0) return 0;

  switch (dhara) {
    case '30_30':
      return Math.ceil(days / 30) * 30;
    case '30_15':
      return slabDhara(days, 30);
    case '15_15':
      return slabDhara(days, 15);
    case '30_day':
      return days <= 30 ? 30 : 30 + (days - 30);
    case '15_day':
      return days <= 15 ? 15 : 15 + (days - 15);
    default:
      return days <= 30 ? 30 : 30 + (days - 30);
  }
}

export function computeInterest(principal, ratePercent, actualDays, dhara) {
  const chargedDays = computeChargedDays(actualDays, dhara);
  const daily = (Number(principal) * Number(ratePercent) / 100) / 360;
  return {
    interest: Math.round(daily * chargedDays),
    chargedDays,
    actualDays: Math.max(0, Math.floor(Number(actualDays) || 0))
  };
}

export function calendarDaysBetween(startDate, endDate) {
  const s = startDate instanceof Date ? startDate : new Date(startDate);
  const e = endDate instanceof Date ? endDate : new Date(endDate);
  if (Number.isNaN(s.getTime()) || Number.isNaN(e.getTime())) return 0;
  return Math.max(0, Math.ceil((e - s) / (1000 * 60 * 60 * 24)));
}

export function resolvePledgeDhara(pledge, defaultDhara = DEFAULT_DHARA_LEGAL) {
  return pledge?.loanDetails?.dhara || defaultDhara;
}

/** Interest from pledge date to today (or release date if already closed). Uses that pledge's rate + dhara. */
export function interestTillDate(pledge, asOf = new Date(), defaultDhara = DEFAULT_DHARA_LEGAL) {
  const principal = Number(pledge?.loanDetails?.principalAmount) || 0;
  const rate = Number(pledge?.loanDetails?.rateOfInterest) || 0;
  const start = pledge?.date;
  if (!principal || !rate || !start) return 0;
  const status = String(pledge?.status || '').toUpperCase();
  const closedAt = pledge?.releaseDate || pledge?.releasedAt || pledge?.closedDate || pledge?.closedAt;
  const end =
    (status === 'RELEASED' || status === 'CLOSED') && closedAt ? closedAt : asOf;
  const actualDays = calendarDaysBetween(start, end);
  const dhara = resolvePledgeDhara(pledge, defaultDhara);
  return computeInterest(principal, rate, actualDays, dhara).interest;
}
